import { createAsyncAction } from 'typesafe-actions';
import { ErrorMessage, Species, Bulletin, Link } from '../../services/types';

export const loadSpecies = createAsyncAction(
  'LOAD_SPECIES_REQUEST',
  'LOAD_SPECIES_SUCCESS',
  'LOAD_SPECIES_FAILURE'
)<undefined, Species[], ErrorMessage>();


export const loadBulletin = createAsyncAction(
  'LOAD_BULLENTIN_REQUEST',
  'LOAD_BULLENTIN_SUCCESS',
  'LOAD_BULLENTIN_FAILURE'
)<string, Bulletin[], ErrorMessage>();

export const loadLinks = createAsyncAction(
  'LOAD_LINK_REQUEST',
  'LOAD_LINK_SUCCESS',
  'LOAD_LINK_FAILURE'
)<string, Link[], ErrorMessage>();

